import { Component, Inject, computed } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppointmentWithGroupedServices } from '../../../models/appointment-grouped-services.model';

@Component({
  selector: 'app-appointment-detail-dialog',
  standalone: false,
  template: `
    <div class="bg-white rounded-2xl overflow-hidden flex flex-col max-h-[90vh]">
      <div class="px-6 py-4 border-b border-slate-100 flex justify-between items-start bg-slate-50/50">
        <div>
          <h2 class="text-xl sm:text-2xl font-bold text-slate-900">{{ data.customerName }}</h2>
          <div class="flex items-center gap-2 text-sm text-slate-600 mt-1">
            <span class="font-semibold text-[#BF7A7A] text-lg">{{ data.timeslotName }}</span>
            <span>•</span>
            <span>{{ data.appointmentDate | date:'dd.MM.yyyy' }}</span>
          </div>
        </div>
        <button (click)="dialogRef.close()" class="text-slate-400 hover:text-slate-600 transition-colors p-1">
          <lucide-icon name="x" class="w-5 h-5"></lucide-icon>
        </button>
      </div>

      <div class="p-6 overflow-y-auto space-y-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="space-y-1">
            <p class="text-sm font-medium text-slate-500">Контакти</p>
            <p class="text-slate-900">{{ data.customerEmail || 'Няма имейл' }}</p>
            <a [href]="'tel:' + data.customerPhone" class="text-blue-600 hover:underline">{{ data.customerPhone }}</a>
          </div>
          <div class="space-y-1">
            <p class="text-sm font-medium text-slate-500">Автомобил</p>
            <p class="text-slate-900 font-medium">{{ data.customerCarBrand }} {{ data.customerCarModel }}</p>
            <p class="text-slate-600 text-sm">{{ data.customerCarYear }} • {{ data.customerCarColor }}</p>
          </div>
        </div>

        @if (data.comment) {
          <div class="bg-amber-50 border border-amber-100 rounded-xl p-3">
            <p class="text-xs font-semibold text-amber-800 mb-1">Коментар</p>
            <p class="text-sm text-amber-900">{{ data.comment }}</p>
          </div>
        }

        <div>
          <p class="text-sm font-medium text-slate-500 mb-3">Услуги</p>
          <div class="space-y-2">
            @for (service of data.services; track service.serviceId) {
              <div class="bg-slate-50 border border-slate-100 p-3 rounded-xl flex justify-between items-center">
                <div>
                  <p class="font-medium text-slate-900">{{ service.serviceName }}</p>
                  <div class="flex flex-wrap gap-1 mt-1">
                    @for (user of service.assignedUsers; track user.userId) {
                      <span class="inline-block bg-white border border-slate-200 text-slate-600 text-[10px] px-2 py-0.5 rounded-md shadow-sm">
                        {{ user.username }}
                      </span>
                    }
                  </div>
                </div>
                <p class="font-semibold text-slate-700">{{ service.price }} €</p>
              </div>
            }
          </div>
          
          <div class="mt-4 flex justify-between items-center border-t border-slate-100 pt-4">
            <p class="font-medium text-slate-600">Обща сума:</p>
            <p class="text-2xl font-bold text-[#BF7A7A]">{{ totalPrice() }} €</p>
          </div>
        </div>
      </div>
    </div>
  `
})
export class AppointmentDetailDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AppointmentDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AppointmentWithGroupedServices
  ) {}

  // 2) Dynamically calculate total price
  totalPrice = computed(() => {
    return this.data.services.reduce((acc, curr) => acc + (Number(curr.price) || 0), 0);
  });
}